import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ActivityContextMenuModule } from '@go-modules/components/activity-view/activity-context-menu/activity-context-menu.module';
import { DataSourceZeroStateModule } from '@go-modules/components/data-source-zero-state/data-source-zero-state.module';
import { FeedbackHoldModule } from '@go-modules/components/feedback-hold/feedback-hold.module';
import { FilterViewLayoutModule } from '@go-modules/components/filter-view-layout/filter-view-layout.module';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { SessionGridModule } from '@go-modules/components/activity-view/session-grid/session-grid.module';
import { SessionListSearchResultInfoModule } from '@go-modules/components/activity-view/session-list-search-result-info/session-list-search-result-info.module';
import { SessionSearchModule } from '@go-modules/components/activity-view/session-search/session-search.module';
import { SessionTableModule } from '@go-modules/components/activity-view/session-table/session-table.module';
import { SessionZeroStateModule } from '@go-modules/components/activity-view/session-zero-state/session-zero-state.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { NgxActivityTaskSessionsComponent } from './activity-task-sessions.component';
import { MediaCardModule } from '@go-modules/components/media-card/media-card.module';
import { TaskDetailsComponent } from './task-details/task-details.component';
import { TaskListNavigatorComponent } from './task-list-navigator/task-list-navigator.component';
import { SanitizePipeModule } from '@go-modules/pipes/sanitize/sanitize.pipe.module';
import {
	ActivityTaskSessionsRoutingModule
} from '@go-modules/components/activity-task-sessions/activity-task-sessions-routing.module';
import { DisabledInteractiveDirective } from '@go-modules/directives/disabled-interactive';
import { PresentTaskAdditionalSettingsComponent } from './present-task-additional-settings/present-task-additional-settings.component';
import { TaskInstructionComponent } from './task-details/instructions-panel/task-instruction.component';
import { ReactTaskAdditionalSettingsComponent } from './react-task-additional-settings/react-task-additional-settings.component';
import { OverviewNavigationComponent } from '@go-modules/components/overview-navigation/overview-navigation.component';
import { ToggleGridListViewComponent } from '../toggle-grid-list-view/toggle-grid-list-view.component';

@NgModule({
	imports: [
		CommonModule,
		ActivityContextMenuModule,
		DataSourceZeroStateModule,
		FeedbackHoldModule,
		FilterViewLayoutModule,
		FormsModule,
		GoSelectModule,
		GoMaterialModule,
		MenuModule,
		MediaCardModule,
		NgxZeroStateModule,
		SanitizePipeModule,
		ReactiveFormsModule,
		SessionGridModule,
		SessionListSearchResultInfoModule,
		SessionSearchModule,
		SessionTableModule,
		SessionZeroStateModule,
		TranslateDirective,
		TranslatePipe,
		ActivityTaskSessionsRoutingModule,
		DisabledInteractiveDirective,
		PresentTaskAdditionalSettingsComponent,
		TaskDetailsComponent,
		TaskInstructionComponent,
		ReactTaskAdditionalSettingsComponent,
		TaskListNavigatorComponent,
		OverviewNavigationComponent,
		ToggleGridListViewComponent
	],
	declarations: [
		NgxActivityTaskSessionsComponent
	],
	exports: [
		NgxActivityTaskSessionsComponent
	]
})
export class ActivityTaskSessionsModule {}
